import { ToolkitPromptFormModal } from '@/ui/components/ToolkitPromptFormModal';
import { useSavePromptToToolkit } from '@/ui/components/ToolkitModal/hooks';
import { SAVE_PROMPT_TO_TOOLKIT_TOOLTIP } from '@/ui/features/chat/components/ChatMessage';

export interface SavePromptToToolkitModalProps {
  visible: boolean;
  onHide: () => void;
  initialPrompt: string;
}

export const SavePromptToToolkitModal = ({ visible, onHide, initialPrompt }: SavePromptToToolkitModalProps) => {
  const { handleSubmit, isLoading } = useSavePromptToToolkit({ onSuccess: onHide });

  return (
    <ToolkitPromptFormModal
      visible={visible}
      onHide={onHide}
      title={SAVE_PROMPT_TO_TOOLKIT_TOOLTIP}
      initialValues={{ toolName: '', toolDescription: '', prompt: initialPrompt }}
      onSubmit={handleSubmit}
      isSubmitting={isLoading}
    />
  );
};
